import React from 'react'

const RightLabel = props => <label style={{ flex: 1, textAlign: 'right', whiteSpace: 'unset', ...props.style }}>{props.children}</label>

export default RightLabel
